import { API } from './API';

const DEFAULT_OPTIONS = {
  baseUrl: 'users',
};

export class UsersAPI extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  list(orgId) {
    const params = [orgId];
    return super.get({ params });
  }

  update(orgId, personId, data) {
    const params = [orgId, personId];
    return super.put({ params }, data);
  }

  create(orgId, data) {
    const params = [orgId];
    return super.post({ params }, data);
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/UsersAPI.js